import { getDateInFormat } from "@domains/utils/reportDates";
export var partnerCertificationMapper = function (data) {
    var certDetails = data.data;
    var partnerCertDetails = {
        certificationDetails: [],
    };
    certDetails.forEach(function (item) {
        partnerCertDetails.certificationDetails.push({
            partnerCode: item.partner_code,
            certificationStartDate: getDateInFormat(item.certification_start_date, "DD MMM YY"),
            certificationEndDate: getDateInFormat(item.certification_end_date, "DD MMM YY"),
            certificationNo: item.certification_no,
            certificationType: item.certification_type,
            refreshDate: getDateInFormat(item.refresh_date, "DD MMM YY"),
        });
    });
    return partnerCertDetails;
};
